const UpdatePassword = () => import('@/views/main/employee/UpdatePassword.vue')
export default {
  path: '/main/employee/updatePassword',
  name: 'UpdatePassword',
  component: UpdatePassword,
  children: []
}
